import * as React from 'react';
import { useField } from 'informed';
import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import 'react-datepicker/dist/react-datepicker.min.css';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { Required } from '../validation/Required';
import { DatePicker } from './DatePicker';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { DatePickerAcceptDateRange } from './DatePicker';

interface ConfigFieldDatePickerProps {
    id: string;
    field: string;
    className: string;
    disabled?: boolean;
    required: boolean;
    onBlur?: (value: string) => void;
    itemId: ConfigurableDataItemIds;
    includeTime?: boolean;
    acceptDateRange?: DatePickerAcceptDateRange
}

export const ConfigFieldDatePicker = (props: ConfigFieldDatePickerProps): JSX.Element => {
    const {
        id,
        field,
        className,
        disabled,
        required,
        onBlur,
        itemId,   
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    const { fieldState, fieldApi } = useField<string>({ field: field, validate: item.importanceId === DataItemImportance.Mandatory ? Required : undefined });

    const { setValue } = fieldApi;

    if (dataItemConfigurationCollection === null)
        throw 'Fields Configurations is not set';

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <DatePicker
                id={id}
                label={item.displayText}
                fieldState={fieldState}
                fieldApi={fieldApi}
                setValue={setValue}
                className={className}
                disabled={disabled}
                required={required}
                onBlur={onBlur}
                includeTime={props.includeTime}
                acceptDateRange={props.acceptDateRange}
            />          
        </Condition>
    </>
}
